/**
 * @generated SignedSource<<67e4719352acffdbbe3e7dc3d89996f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PricingGuidancePriceRange = "HIGHER_RANGE" | "LOWER_RANGE" | "MEDIAN" | "NEAR_MEDIAN_HIGH" | "NEAR_MEDIAN_LOW" | "OUT_OF_RANGE_HIGH" | "OUT_OF_RANGE_LOW" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbPricingGuidance_item$data = {
  readonly pricingGuidance: {
    readonly priceRange: PricingGuidancePriceRange | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPricingGuidanceSoldLink_item" | "pricingGuidanceHelpers_item" | "useSoldItemLinksPdpClientVariant_item">;
  readonly " $fragmentType": "PdpRespSidebarBlurbPricingGuidance_item";
};
export type PdpRespSidebarBlurbPricingGuidance_item$key = {
  readonly " $data"?: PdpRespSidebarBlurbPricingGuidance_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbPricingGuidance_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceRange",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbPricingGuidance_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PricingGuidance",
      "kind": "LinkedField",
      "name": "pricingGuidance",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "pricingGuidanceHelpers_item",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PricingGuidance",
          "kind": "LinkedField",
          "name": "pricingGuidance",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pricingGuidanceType",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "price",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            },
            {
              "kind": "Variable",
              "name": "isTrade",
              "variableName": "isTrade"
            },
            {
              "kind": "Variable",
              "name": "priceBookName",
              "variableName": "priceBookName"
            },
            {
              "kind": "Variable",
              "name": "userCountryCode",
              "variableName": "userCountryCode"
            }
          ],
          "concreteType": "ItemDisplayPriceType",
          "kind": "LinkedField",
          "name": "displayPrice",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": [
        {
          "kind": "RootArgument",
          "name": "isTrade"
        },
        {
          "kind": "RootArgument",
          "name": "priceBookName"
        },
        {
          "kind": "RootArgument",
          "name": "userCountryCode"
        },
        {
          "kind": "RootArgument",
          "name": "userId"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPricingGuidanceSoldLink_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSoldItemLinksPdpClientVariant_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "f54695c51557cdbc65a55411d6499e2c";

export default node;
